import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlusLarge"><Path d="M12 3.5V12M12 12V20.5M12 12H3.5M12 12H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlusLarge;
